import { SlidersHorizontal } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerPropertiesSpec: ModuleSpec = {
  id: "customer-properties",
  icon: SlidersHorizontal,
  i18n: {
    namespace: "modules",
    titleKey: "customer-properties.title",
    descriptionKey: "customer-properties.description",
  },
  nav: {
    path: "/customers/properties",
    group: "observe",
    order: 90,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Manage profile and session properties",
  },
};
